export function accessibility() {
  /* Tab navigation skip to content */
  const skipLink = document.querySelector('.skip-link');
  const skipTo = skipLink.hash.replace(/#/, '');
  const skipToElement = document.getElementById(skipTo);
  skipLink.addEventListener('click', function () {
    // Add focus to element
    skipToElement.setAttribute('tabindex', -1);
    skipToElement.focus();
    // Remove focus on focus lost
    skipToElement.addEventListener('focusout', function () {
      skipToElement.removeAttribute('tabindex');
    })
  });

  /* Enable focusring on keyboard navigation */
  document.body.addEventListener('keydown', function (event) {
    if (event.key == 'Tab') {
      document.body.className = 'keyboard-nav';
    }
  });

  /* Disable focusring on mouse click */
  document.body.addEventListener('click', function () {
    let curBodyClass = document.body.className;
    if (curBodyClass == 'keyboard-nav') {
      document.body.classList.remove('keyboard-nav');
    }
  });

  /* New window to external link warning */
  document.querySelectorAll('a[target=_blank]').forEach(function (e) {
    e.insertAdjacentHTML('beforeend', '<span class="screen-reader-text"> (opens in a new window)</span>');
  });
}